var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('h2',[_vm._v("Page not found")]),_c('i',{staticClass:"fas fa-exclamation-triangle red--text"}),_c('p',[_vm._v(" We're sorry, the page you requested could not be found. Please go back to the homepage or contact us at admin@bibekshakya.com ")]),_c('h1',[_vm._v("404")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }